export default __webpack_public_path__ + "static/media/icon-close.d2befdd0.svg";